export const API_BASE_URL = 'https://plansync-backend-234288438538.us-central1.run.app';
export const DOCUMENTS_API_URL = 'https://plansync-backend-234288438538.us-central1.run.app';
export const LOCAL_API_URL = 'http://127.0.0.1:8000';